let slickDefaults = require('../slick-default/slick-default');
let size = require('../../modules/size');
require('./section-slider.less');

jQuery(function($) {
    var defaultOptions = $.extend({}, slickDefaults.params, slickDefaults.paramsCssAnim, {
        slidesToShow: 3,
        responsive: [
            {
                breakpoint: size.desktop,
                settings: { slidesToShow: 2 }
            },
            {
                breakpoint: size.tabletBig,
                settings: { slidesToShow: 1 }
            }
        ]
    });

    $('.js-slider-sections-mobile:not(#sectionsSlider)').each(function() {
        var $psSlider = $(this);

        $psSlider.slick(
            $.extend({}, defaultOptions, {
                slidesToShow: 1,
                dots: true,
                arrows: true,
                responsive: []
            })
        );
    });

    let $slider = $('#sectionsSlider');
    $slider.slick(
        $.extend({}, defaultOptions, {
            slidesToShow: 4,
            dots: true,
            arrows: false,
            responsive: [
                {
                    breakpoint: 670,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 520,
                    settings: {
                        slidesToShow: 2
                    }
                }
            ]
        })
    );
});



// WEBPACK FOOTER //
// ./blocks/section-slider/section-slider.js